import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut } from './utils'

export const getReviewSend = (projectVersionId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/review-form/`
  return doGet(url)
}

export const saveReviewSend = (request) => {
  const url = `${API_ROOT}/review/review-form`
  return doPost(url, request)
}

export const saveDraftReviewSend = (request) => {
  const url = `${API_ROOT}/review/review-form/draft`
  return doPost(url, request)
}
